import React, { useRef, useState } from 'react'
import { BsFillCloudUploadFill } from 'react-icons/bs'
import Loader from './Loader';
import styles from "./styles.module.css";

function SideBar(props) {

  const fileInputRef = useRef(null);

  return (
    <>
      <div className="relative min-h-screen md:flex" data-dev-hint="container">
        <input type="checkbox" id="menu-open" className="hidden" />
        <label
          htmlFor="menu-open"
          className="absolute right-2 bottom-2 shadow-lg rounded-full p-2 bg-gray-100 text-gray-600 md:hidden"
          data-dev-hint="floating action button"
        >
          {/* <svg
      className="h-6 w-6"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 6h16M4 12h16M4 18h16"
      />
    </svg> */}
        </label>
        <header
          className="bg-gray-600 text-gray-100 flex justify-between md:hidden"
          data-dev-hint="mobile menu bar"
        >
          <a
            href="#"
            className="block p-4 text-white font-bold whitespace-nowrap truncate"
          >
            Your App is cool
          </a>
          <label
            htmlFor="menu-open"
            id="mobile-menu-button"
            className="m-2 p-2 focus:outline-none hover:text-white hover:bg-gray-700 rounded-md"
          >
            <svg
              id="menu-open-icon"
              className="h-6 w-6 transition duration-200 ease-in-out"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
            <svg
              id="menu-close-icon"
              className="h-6 w-6 transition duration-200 ease-in-out"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </label>
        </header>
        <aside
          id="sidebar"
          className="bg-gray-800 text-gray-100 md:w-64 w-3/4 space-y-6 pt-6 px-0 absolute inset-y-0 left-0 transform md:relative md:translate-x-0 transition duration-200 ease-in-out  md:flex md:flex-col md:justify-between overflow-y-auto"
          data-dev-hint="sidebar; px-0 for frameless; px-2 for visually inset the navigation"
        >
          <div
            className="flex flex-col space-y-6 p-3"
            data-dev-hint="optional div for having an extra footer navigation "
          >
            <a
              href="#"
              className="text-white flex items-center space-x-2 px-4"
              title="Your App is cool"
            > 
                 <span className="text-base  whitespace-nowrap truncate">        
            Current limitations : 
            </span>
            </a>
            <br/>
            * Supported only   upto 400kb filesize
            <br/>
     
            <br/>
            * Potential glitches may be felt as its on beta mode

            <br/>
            <br/>
            * We are not saving any resumes for future reference.
            <br/>
            <br/>
            * Only 10 questions can be created

            

            <br/>
            <br/>
            * UI UX is not finalized as I am concentrating on the backend features for this.


          </div>
          {/* <nav data-dev-hint="second-main-navigation or footer navigation">
            <a
              href="#"
              className="block py-2 px-4 transition duration-200 hover:bg-gray-700 hover:text-white"
            >
              asd
            </a>
            <a
              href="#"
              className="block py-2 px-4 transition duration-200 hover:bg-gray-700 hover:text-white"
            >
              asd
            </a>
            <a
              href="#"
              className="block py-2 px-4 transition duration-200 hover:bg-gray-700 hover:text-white"
            >
              asd
            </a>
          </nav> */}
        </aside>
        <main id="content" className="flex-1 p-6 lg:px-8">
      {props.isLoading&& <Loader/>}

{props.windowState=='init'?
          <div className="max-w-7xl mx-auto">
            {/* Replace with your content */}
            <div className="px-4 py-6 sm:px-0">
              <div className="border-4 border-dashed border-gray-200 rounded-lg h-96" >


                <div className="flex flex-col items-center justify-center h-96" onClick={()=>{document.getElementById("file-input").click()}}>
                  <BsFillCloudUploadFill size={80} />
                  <br />
                  <div id="newine">
                    Upload Your Resume       </div>
                  <input
                    type="file"
                    id="file-input"
                    style={{ display: 'none' }}
                    onChange={(e)=>{props.handleFileInputChange(e)}}
                    ref={fileInputRef}
                  />

                </div>
              </div>
            </div>
            {/* /End replace */}
          </div>
:<>   

{/* your chat screen */}




<div className="glass">

  {!props.aiResponse?
<>  <h1 className='text-white'>Now, Enter the Candidate Requirement</h1> 
  <div className="input">
    {" "}
    <input
      type="text"
      id="userBox"
      placeholder="Type your Requirements for eg: Python developer with 2year experience, should have a cs degree"
      onChange={(e)=>{props.setRequirement(e.target.value)}}
    />{" "}
  </div>{" "}
  {/* <p id="chatLog">Answer Appering Hear</p>{" "} */}

<div className='flex justify-center'>
<button  className={styles.btn}  onClick={()=>{props.uploadFileAndGenerateResponse()}}> Submit  </button>

</div>
</>
:<>

<div>

<div className='text-slate-100'>
      {/* Render lines with <li> for items */}
      <ul>
        {props.aiResponse.map((line, index) => {
          if (/^\d+\./.test(line)) {
            // Line starts with a number followed by a period, treat as item
            return <li key={index}>{line}</li>;
          } else {
            // Regular line, render as text
            return <p key={index}>{line}</p>;
          }
        })}
      </ul>
    </div>

</div>

</>}
</div>


</>}
        </main>
      </div>

    </>
  )
}

export default SideBar